import { dateToSeconds } from '@/lib/util/dateTime';
import { BreakType } from '@/stores/timesheets';
import { getUnpaidBreakTemplate, getPaidBreakTemplate } from './breakTemplates';

export function getBreakType(state: any) {
  return state.breakType == getUnpaidBreakTemplate().SlotLabel
    ? BreakType.Unpaid
    : BreakType.Paid;
}

export function getBreakName(state: any) {
  return state.breakType == getUnpaidBreakTemplate().SlotLabel
    ? getUnpaidBreakTemplate().SlotName
    : getPaidBreakTemplate().SlotName;
}

export function addBreak(state: any, intEnd: number, intStart: number) {
  state.breaks.push({
    blnEmptySlot: false,
    intEnd: intEnd,
    intStart: intStart,
    intUnixEnd: dateToSeconds(
      state.break.endDate.getFullYear(),
      state.break.endDate.getMonth() + 1,
      state.break.endDate.getDate(),
      state.break.endTime.data.HH,
      state.break.endTime.data.mm
    ),
    intUnixStart: dateToSeconds(
      state.break.startDate.getFullYear(),
      state.break.startDate.getMonth() + 1,
      state.break.startDate.getDate(),
      state.break.startTime.data.HH,
      state.break.startTime.data.mm
    ),
    mixedActivity: {
      intState: 2,
      blnCanStartEarly: 1,
      blnCanEndEarly: 1,
      blnIsMandatory: 1,
      strBreakType: getBreakType(state),
    },
    strState: 'Finished',
    strType: 'B',
    strTypeName: getBreakName(state),
  });

  return state.breaks;
}
